<template>
  <div>
    <h1 class="onboarding__title mb-5">
      {{ $t('onboarding.success.thanksMessage') }}
    </h1>
    <p class="mb-15">
      {{ $t('onboarding.success.confirmationMessage') }}
    </p>
    <p class="text-center">
      <v-btn @click="callAppointmentCreate" color="primary" elevation="0" large>
        {{ $t('onboarding.success.createAppointment') }}
      </v-btn>
    </p>
    <p class="text-center">
      <v-btn
        href="/"
        target="_blank"
        rel="noopener"
        elevation="0"
        text
      >
        {{ $t('onboarding.success.createAnotherTime') }}
      </v-btn>
    </p>
  </div>
</template>

<script>
import router from '@/router'

export default {
  name: 'OnboardingStepsSuccess',

  methods: {
    callAppointmentCreate() {
      router.push('/appointments?createAppointment=true')
    },
  },
}
</script>
